"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceS3WithCloudFront = exports.checkStorageUrlIsS3 = void 0;
function checkStorageUrlIsS3(storageUrl) {
    try {
        const url = new URL(storageUrl);
        return true;
    }
    catch (err) {
        return false;
    }
}
exports.checkStorageUrlIsS3 = checkStorageUrlIsS3;
function replaceS3WithCloudFront(assetUrl) {
    const cloudFrontUrl = process.env.CLOUD_FRONT_URL;
    if (!assetUrl || !cloudFrontUrl) {
        return assetUrl;
    }
    try {
        const parsed = new URL(assetUrl);
        const host = parsed.hostname;
        if (!host.endsWith("amazonaws.com") || !host.includes("s3")) {
            return assetUrl;
        }
        const segments = parsed.pathname.replace(/^\/+/, "").split("/");
        let path = "";
        if (host === "s3.amazonaws.com" || /^s3[.-][a-z0-9-]+\.amazonaws\.com$/.test(host)) {
            path = segments.slice(1).join("/");
        }
        else {
            path = segments.join("/");
        }
        if (!path) {
            return assetUrl;
        }
        return `${cloudFrontUrl.replace(/\/$/, "")}/${path}`;
    }
    catch (err) {
        return assetUrl;
    }
}
exports.replaceS3WithCloudFront = replaceS3WithCloudFront;
//# sourceMappingURL=s3-helper.js.map